import { type ProcessDoc } from '../rxdb/collections/processes';
import { useDatabase } from '../rxdb/provider';
import { useEffect, useState } from 'react';

export const useProcesses = (workspaceId?: null | string) => {
  const { db } = useDatabase();
  const [processes, setProcesses] = useState<ProcessDoc[]>([]);

  useEffect(() => {
    const query = workspaceId
      ? db.processes.find({
          selector: {
            workspaceId,
          },
        })
      : db.processes.find();

    const sub = query.$.subscribe((docs) => {
      setProcesses(docs.map((doc) => doc.toJSON()));
    });
    return () => sub.unsubscribe();
  }, [db, workspaceId]);

  return { processes };
};
